module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;

    var alignPosition = 'left';
    if (!u.isTrue(buttonPositionLeft)) {
        alignPosition = 'right';
    }


    ; __append("\r\n")
    ;  
    let localizedLabelAttach = u.getLocalizedText(id, 'buttonLabelAttach') || buttonLabelAttach; 

    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control textinput has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;\r\n             width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append(";\">\r\n\r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n    <div class=\"pf-control-core pf-selectable\" style=\"background-color: ")
    ; __append(escapeFn(backgroundColor))
    ; __append(";\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;\r\n                border-radius: 0px;\r\n                border: 1px dotted #ffffff;\r\n                width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: auto; \r\n                white-space: nowrap;\">\r\n            <button filesize=\"")
    ; __append(escapeFn( fileSize ))
    ; __append(">\"\r\n                    style=\"height:")
    ; __append(escapeFn(u.extractNum(height)))
    ; __append("px; width: auto;\r\n                            overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\r\n                            border: 1px solid #cecece;\r\n                            border-radius: 2px;\r\n                            float: ")
    ; __append(escapeFn(alignPosition))
    ; __append(";\r\n                            font-family: '")
    ; __append(escapeFn(buttonFontFamily))
    ; __append("';\r\n                            font-size: ")
    ; __append(escapeFn(buttonFontSize))
    ; __append("px;\r\n                            font-style: ")
    ; __append(escapeFn(buttonTextStyle))
    ; __append(";\r\n                            font-weight: ")
    ; __append(escapeFn(buttonTextWeight))
    ; __append(";\r\n                            color: ")
    ; __append(escapeFn(buttonTextColor))
    ; __append(";\r\n                            background: ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(";\r\n                            background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                            background: -webkit-linear-gradient(0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                            background: -moz-linear-gradient(center top,  ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(", ")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append(");\r\n                            background: linear-gradient(to bottom, ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(", ")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append(");\"\r\n            >")
    ; __append(escapeFn(localizedLabelAttach))
    ; __append("</button> <span style=\"margin-left: 5px;\r\n                font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append("; font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n                font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n                color: ")
    ; __append(escapeFn(styleColorText))
    ; __append(";\r\n                background-color: ")
    ; __append(escapeFn(backgroundColor))
    ; __append(";\r\n                line-height: ")
    ; __append(escapeFn( u.shrink(height) + 5 ))
    ; __append("px;\">Status</span>\r\n    </div>\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n</div>\r\n\r\n\r\n\r\n")
  }
  return __output;

}